import { useGetAPI, usePostAPI } from './useAPI';
import { APICallProps } from '@types';

export const useInitiateBulkDownload = () => {
	const { isLoading, data, error, callAPI } = usePostAPI({
		endpoint: '/api/shipper/bulk-document-download',
	});

	return {
		isInitiating: isLoading,
		initiateData: data as { label: string } | null,
		initiateError: error,
		callInitiateBulkDownload: callAPI as (props?: APICallProps) => Promise<{
			data: { label: string } | null;
			error: any | null;
		}>,
	};
};

export const useGetBulkDownloadStatus = (label: string) => {
	const { isLoading, data, error, callAPI } = useGetAPI({
		endpoint: `/api/shipper/bulk-document-download/${label}`,
	});

	return {
		isCheckingStatus: isLoading,
		statusData: data,
		statusError: error,
		callGetStatus: callAPI as (props?: APICallProps) => Promise<{
			data: {
				job_status: string;
				processed?: number;
				total?: number;
				skipped?: number;
				url?: string;
				expires_at?: number;
			} | null;
			error: any | null;
		}>,
	};
};
